import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import SmartMessageComposer from "@/components/SmartMessageComposer";

/**
 * EmailButton — opens the unified SmartMessageComposer pre-set to the EMAIL
 * channel. Mirrors WhatsAppButton's API so any place that already has phone /
 * email / contact context can drop this in for an explicit "send email"
 * affordance with attachments support (mailto: would lose attachments).
 */
export default function EmailButton({
  email,
  phone,
  contactName,
  dealTitle,
  dealId,
  clientId,
  clientCompany,
  meetingWhen,
  meetingLocation,
  action,
  event,
  defaultTemplate,
  size = "sm",
  variant = "outline",
  label,
  testId,
  followupId,
  onSent,
}) {
  const [open, setOpen] = useState(false);
  if (!email) return null; // nothing to do without a target

  const isIconOnly = size === "icon";
  const initialSituation = defaultTemplate || (action ? "follow_up_action" : meetingWhen ? "meeting_confirm" : dealTitle ? "follow_up_deal" : "intro");

  return (
    <>
      <Button
        type="button"
        variant={variant}
        size={size}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        className="rounded-2xl tap text-sky-700 border-sky-200 hover:bg-sky-50 hover:text-sky-800"
        data-testid={testId || "email-button"}
      >
        <Mail className={isIconOnly ? "h-4 w-4" : "h-3.5 w-3.5 mr-1"} />
        {!isIconOnly && (label || "Email")}
      </Button>

      <SmartMessageComposer
        open={open}
        onOpenChange={setOpen}
        contact={{ name: contactName, phone, email, company: clientCompany }}
        deal={dealTitle ? { id: dealId, title: dealTitle } : null}
        client={{ id: clientId, company_name: clientCompany, contact_person: contactName }}
        defaultSituation={initialSituation}
        action={action}
        meetingWhen={meetingWhen}
        meetingLocation={meetingLocation}
        event={event}
        followupId={followupId}
        onActivityLogged={onSent}
      />
    </>
  );
}
